export default __webpack_public_path__ + "static/media/back.c6537696.png";